import FindDentistHeader from "../../components/FindDentist/FindDentistHeader";
import DentistSignUpForm from "../../components/FindDentist/DentistSignUpForm";

const DentistEnrollment = () => {
  return (
    <div className="bg-light">
      <FindDentistHeader />
      <DentistSignUpForm />
    </div>
  );
};

export default DentistEnrollment;
